export const legacyTheme = {
  colors: {
    grayMiddle: '#808080',
    grayLighterMiddle: '#dcdcdc',
    grayLighterDarker: '#999',
    grayLightest: '#f9f9f9',
    tableBorder: '#ddd',
    contrastLink: '#0da1a9'
  }
}
